import { Component, OnInit } from '@angular/core';

import { NotificationsComponent }
  from 'app/shared/components/notifications/notifications.component';

import { FavoriteComponent }
  from 'app/shared/components/favorite/favorite.component';

//enums
import { GeneratorType, ChartType } from 'app/shared/models/enum/query-builder';
//services
import { RoleService } from 'app/shared/services/control/role/role.service';
import { AssignChartService, GenerateTableService, AssignCardService, DashboardGeneratorService } from 'app/shared/services/query-builder';
import { UserRoleService } from 'app/shared/services/control/user-role/user-role.service';
import { BaseComponent } from 'app/shared/infrastructure';
import { ActivatedRoute } from '@angular/router';
import { NotificationService } from 'app/shared/services';

@Component({
  selector: 'dashboard',
  styleUrls: ['./dashboard.scss'],
  templateUrl: './dashboard.html'
})
export class Dashboard extends BaseComponent implements OnInit {
  notificationComponent = { type: NotificationsComponent };
  favoriteComponent = { type: FavoriteComponent };
  availableGenerators: any[] = [];
  originaleGenerators: any[] = [];
  selectedRoleInformation = null;
  selectedGenerators: any[] = [];
  multiSelectedGenerators: any[] = [];
  draggedGenerator: any = null;
  isActiveNavbar: boolean = false;
  generatorType = GeneratorType;
  chartType = ChartType;
  roles: any[] = [];
  selectedRole: any = null;
  enableEditWidget: boolean = false;
  isEditable: boolean = false;
  userRoles: any[];
  constructor(private _assignChartService: AssignChartService,
    private _generateTableService: GenerateTableService,
    private _assignCardService: AssignCardService,
    private _dashboardGeneratorService: DashboardGeneratorService,
    private userRoleService: UserRoleService,
    private _route: ActivatedRoute,
    private _notificationService: NotificationService) {
    super();
    this.getParams();
  }

  ngOnInit(): void {
    this.enableEditWidget = this.validatePermission('EnableEditWidget');
    this.getChart();

  }

  getParams() {
    const noteId: string = this._route.snapshot.params.notificationId;
    if (noteId) {
      this._notificationService.onOpenNotification.next(noteId);
    }
  }

  getByRoleId(event = null) {
    this._dashboardGeneratorService.getByRoleId(event !== null ? event : this.selectedRole)
      .subscribe((data: any) => {
        this.selectedGenerators = [];
        if (data !== null && data.DashboardGeneratorDetails.length > 0) {
          this.mapItem(data.DashboardGeneratorDetails);
        } else {
          this.selectedRoleInformation = null;
          this.selectedGenerators = [];
        }
      },
        error => {
          this.showError(error);
        });
  }

  mapItem(items) {
    const availableGenerators = [...this.availableGenerators];
    items.forEach(element => {
      let item = Object.assign({}, availableGenerators.find(f => f.Id === element.QueryGeneratorId && f.GeneratorType === element.GeneratorType));
      if (item && item.Id) {
        item.widgetSize = element.WidgetSize;
        item.generatedId = this.generateId();
        this.selectedGenerators.push(item);
      }
    });

  }

  getChart() {
    this._assignChartService.get()
      .subscribe((data: any[]) => {
        this.availableGenerators = [];
        if (data) {
          data.forEach(element => {
            element.QueryGeneratorId = element.Id;
            element.GeneratorType = GeneratorType.Chart;
          });
        }
        this.getTable(data)
      });
  }

  getTable(charts) {
    this._generateTableService.get()
      .subscribe((data: any[]) => {
        if (data) {
          data.forEach(element => {
            element.QueryGeneratorId = element.Id;
            element.GeneratorType = GeneratorType.Table;
          });
        }
        this.getCards(charts, data);
      });
  }


  getCards(charts, tables) {
    this._assignCardService.get()
      .subscribe((data: any[]) => {
        let items = [];
        items = [].concat(charts, tables);
        data.forEach(element => {
          element.QueryGeneratorId = element.Id;
          element.GeneratorType = GeneratorType.Card;
          items.push(element);
        });

        items.forEach((element, index) => {
          element.index = index + 1;
        });
        this.setPermittedWidgets(items);

      });
  }

  setPermittedWidgets(items) {
    const prefix = (`wid_`).toLocaleLowerCase();
    let availableItems = [...items];
    availableItems.forEach(element => {
      const name = `${prefix}${element.QueryGenerator.Title.replace(" ", "_")}`
      if (!this.validatePermission(name)) {
        items = [...items.filter(f => f !== element)];
      };
    });
    this.originaleGenerators = [...items];
    this.availableGenerators = items;
    this.getLoggedUserRoles();
  }

  getLoggedUserRoles() {
    this.userRoleService.getRolesByUser(this.user.id)
      .subscribe((data: any[]) => {
        this.userRoles = [];
        this.roles = [];
        this.userRoles = data;

        data.forEach((role) => this.roles.push({ label: role.RoleTitle, value: role.RoleId }));
        this.getByRoleIds();
      },
        error => this.showError(error));
  }

  getByRoleIds() {
    const data = this.userRoles.map(m => m.RoleId);
    if (data.length === 0) {
      return;
    }

    const query = {
      RoleIds: data
    }
    this._dashboardGeneratorService.getByRoleIds(query)
      .subscribe((data: any) => {
        this.multiSelectedGenerators = [];
        if (data.length > 0) {
          data.forEach(element => {
            let selectedGenerators = [];
            const availableGenerators = [...this.availableGenerators];
            element.DashboardGeneratorDetails.forEach(generateItem => {
              let item = Object.assign({}, availableGenerators.find(f => f.Id === generateItem.QueryGeneratorId && generateItem.GeneratorType === f.GeneratorType));

              if (item && item.Id) {
                item.widgetSize = generateItem.WidgetSize;
                item.generatedId = this.generateId();
                selectedGenerators.push(item);
              }
            });
            this.multiSelectedGenerators.push(selectedGenerators);
          });
        } else {
          this.multiSelectedGenerators = [];
        }
      },
        error => {
          this.showError(error);
        });

  }

  dragStart(event, item: any) {
    this.draggedGenerator = item;
  }

  drop(event) {
    if (this.draggedGenerator) {
      let isExist = this.selectedGenerators.find(f => f.Id === this.draggedGenerator.QueryGeneratorId && this.draggedGenerator.GeneratorType === f.GeneratorType);
      if (!isExist) {
        let items = [...this.selectedGenerators];
        items.push(this.draggedGenerator);
        this.selectedGenerators = [...items];
      } else {
        this.showError("This widget already exist");
      }
      this.isActiveNavbar = false;
      this.draggedGenerator = null;
    }
  }

  dragEnd(event) {
    this.draggedGenerator = null;
  }

  onActivateNavbar() {
    this.isActiveNavbar = !this.isActiveNavbar;
  }

  onSetResult(items) {
    this.selectedGenerators = items;
  }

  onfilter(event) {

    let items = [...this.originaleGenerators];

    if (event.target.value !== "") {
      items =
        items.filter((f) =>
          f.QueryGenerator.Title.toLowerCase().includes(
            event.target.value.toLowerCase()) ||
          f.QueryGenerator.Description.toLowerCase().includes(event.target.value.toLowerCase())
        )
    }

    this.availableGenerators = [...items];
  }

  onSubmit() {

    if (this.selectedGenerators.length === 0) {
      this.showError("You should Set widget");
      return;
    } else {
      let widgets = [];
      this.selectedGenerators.forEach(element => {
        widgets.push({
          GeneratorType: element.GeneratorType,
          QueryGeneratorId: element.QueryGeneratorId,
          WidgetSize: element.widgetSize,
          ChartType: element.ChartType ? element.ChartType : null,
        })
      })
      let data = {
        RoleId: this.selectedRole,
        DashboardGeneratorDetails: widgets

      }

      this._dashboardGeneratorService.add(data)
        .subscribe(() => {
          this.showSuccess("Widgets has been set successfully");
        },
          error => {
            this.showError(error);
          });

    }
  }

  onToggleEdit() {
    this.isEditable = !this.isEditable;
    this.selectedGenerators = [];

    if (this.isEditable) {
      this.selectedRole = this.roles.length > 0 ? this.roles[0].value : null;
      if (this.selectedRole) {
        this.getByRoleId()
      }
    }
  }

  setCount(index) {
    return index + 1;
  }

  generateId() {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    for (var i = 0; i < 20; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }
}